import { PropTypes } from "prop-types";
import React from "react";
import { AdService } from "../../ad-service";
import { CommentingWidget } from "../commenting-widget";
import "./story-footer.module.css";

export const StoryFooter = ({ story }) => {
  return (
    <div>
      <div styleName="ad">
        <AdService adtype="Story-Bottom-Ad" slotId="StoryBottom" />
      </div>
      <div styleName="metype">
        <CommentingWidget story={story} />
      </div>
    </div>
  );
};

StoryFooter.propTypes = {
  story: PropTypes.object
};
